import type { SVGProps } from 'react';
export const Meh = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 49 48" {...props}>
    <path
      fill="#F1BE04"
      d="M24.5 7.2a16.8 16.8 0 1 0 0 33.6 16.8 16.8 0 0 0 0-33.6m0 31.02a14.22 14.22 0 1 1 0-28.44 14.22 14.22 0 0 1 0 28.44m7.75-9.05a1.3 1.3 0 0 1-1.29 1.3H18.04a1.3 1.3 0 1 1 0-2.6h12.92a1.3 1.3 0 0 1 1.3 1.3m-15.5-8.4a1.94 1.94 0 1 1 3.87 0 1.94 1.94 0 0 1-3.87 0m15.5 0a1.94 1.94 0 1 1-3.87 0 1.94 1.94 0 0 1 3.87 0"
    />
  </svg>
);
